  <h1 mat-dialog-title class="justify-content-md-center">{{'generic.confirmation' | translate}}</h1>
  <div mat-dialog-content>
    <p>{{data.question | translate}}</p>
  </div>
  <div mat-dialog-actions class="justify-content-md-center">
    <button mat-flat-button color="primary" type="submit"
            [mat-dialog-close]="true">{{'generic.yes' | translate}}</button>
    <button mat-flat-button (click)="onNoClick()">{{'generic.no' | translate}}</button>
  </div>
